<template>
    <cookie-law buttonClass="button is-primary is-medium"
                :message="$t('global.cookieNotice.message')"
                :buttonText="$t('global.cookieNotice.button')" />
</template>

<script>
    import CookieLaw from 'vue-cookie-law';

    export default {
        components: {
            CookieLaw,
        },
    };
</script>



// WEBPACK FOOTER //
// src/global/components/CookieNotice.vue